// extracted by mini-css-extract-plugin
export default {"root_image_inner":"mediaVideoForm_root_image_inner__M7LJN","formTabs_root":"mediaVideoForm_formTabs_root__crBpr","loader_root":"mediaVideoForm_loader_root__Pm6Rw"};